import FormattedMessage from 'I18n/components/FormattedMessage';
import { HubMerchCardLayoutUI } from '../../containers/merch-card/HubMerchCardLayoutUI';
import { StarterLowerTierMessage } from '../../containers/merch-card/StarterLowerTierMessage';
import { useIsFreePortal } from '../../hooks/inventory/useProductInventory';
import { jsx as _jsx } from "react/jsx-runtime";
export const ServiceHubMerchCards = () => {
  const {
    isFreePortal,
    loading
  } = useIsFreePortal();
  const productsConfig = {
    STARTER: {
      apiName: 'service-hub-starter',
      Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.merchCardsV2.service.starterCard.description"
      }),
      lowerTierMessage: StarterLowerTierMessage({
        isFreePortal,
        loading
      })
    },
    PROFESSIONAL: {
      apiName: 'service-hub-professional',
      Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.merchCardsV2.service.professionalCard.description"
      }),
      lowerTierMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.service.professional.lowerTierPlus"
      })
    },
    ENTERPRISE: {
      apiName: 'service-hub-enterprise',
      Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.merchCardsV2.service.enterpriseCard.description"
      }),
      lowerTierMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-pages-ui.merchCardsV2.priorityFeatures.productLevels.service.enterprise.lowerTierPlus"
      })
    }
  };
  return /*#__PURE__*/_jsx(HubMerchCardLayoutUI, {
    productsConfig: productsConfig
  });
};